import { KbaQuestionType } from '@seapoint/server/enums';

/**
 * Human-readable labels for each KBA (Knowledge-Based Authentication) question type.
 * Used in security question dropdowns during card creation.
 */
export const KBA_QUESTION_LABELS: Record<KbaQuestionType, string> = {
  [KbaQuestionType.FIRST_PET_NAME]: "What was your first pet's name?",
  [KbaQuestionType.MATERNAL_GRANDMOTHER_MAIDEN_NAME]: "What is your maternal grandmother's maiden name?",
  [KbaQuestionType.FAVOURITE_CHILDHOOD_FRIEND]: "What was your favourite childhood friend's name?",
  [KbaQuestionType.FIRST_CAR]: 'What was your first car?',
  [KbaQuestionType.CITY_PARENTS_MET]: 'In what city did your parents meet?',
};

export type SecurityQuestionOption = {
  value: KbaQuestionType;
  label: string;
  key: string;
};

/**
 * Pre-built options array for security question dropdowns.
 * Maps KbaQuestionType enum to label/value pairs.
 */
export const SECURITY_QUESTION_OPTIONS: SecurityQuestionOption[] = Object.entries(KbaQuestionType).map(
  ([key, value]) => ({
    value: value as KbaQuestionType,
    label: KBA_QUESTION_LABELS[value as KbaQuestionType],
    key,
  }),
);
